import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import checkmarkLogo from "../../assets/checkmark.svg";

const OfficerRegistered = ({
  setActiveIndex,
  resetRegData,
  setIsCongrats,
  type,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const closeWizard = () => {
    navigate(
      type === "officer"
        ? `/entity/${id}/officers`
        : `/entity/${id}/powers-of-attorney`,
    );
  };

  const handleAnotherOfficer = () => {
    setActiveIndex(0);
    setIsCongrats(false);
    resetRegData();
  };

  return (
    <div>
      <div className="formgrid grid flex justify-content-center align-item-center">
        <div className="no-key-container">
          <img
            src={checkmarkLogo}
            alt="file-upload"
            className="file-upload-logo"
          />
          <div className="no-key-align">
            <p className="no-key-personnel my-4">
              {type === "officer"
                ? "Officer registered"
                : "Attorney registered"}
            </p>
          </div>
          <button className="add-new-officer" onClick={handleAnotherOfficer}>
            {type === "officer"
              ? "Add Another Officer"
              : "Add Another Attorney"}{" "}
            <span className="pi pi-plus ml-2"></span>
          </button>
          <button
            type="button"
            className="cancel-btns mt-3 close-wizard"
            onClick={closeWizard}
          >
            Close Wizard
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfficerRegistered;
